var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme"},_vm._l((_vm.theme),function(color,index){return _c('div',{key:index},[_c('div',{staticClass:"theme__color",style:('background:' + color)})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }